import CarouselItemDesktop from "./CarouselItemDesktop";
import { Props } from "./types";

const CarouselItem = ({ ...props }: Props): JSX.Element => <CarouselItemDesktop {...props} />;

export default CarouselItem;
